const DRAFT_KEY_PREFIX = 'assessment_draft';
const DRAFT_KEY_SEPARATOR = '|';
const RETENTION_MS = 7 * 24 * 60 * 60 * 1000 // Retention policy of 7 days

const getStorageKeyForDraft = (draftId) => `${DRAFT_KEY_PREFIX}${DRAFT_KEY_SEPARATOR}${draftId}`;

const draftIsOlderThanRetentionLimit = (savedDate) =>
    Date.now() - savedDate > RETENTION_MS

const shouldClearDraft = (savedDate) =>
    (typeof savedDate !== 'number' || draftIsOlderThanRetentionLimit(savedDate))

export function clearDraft(draftId) {
    const draftKey = getStorageKeyForDraft(draftId);

    try {
        window.localStorage.removeItem(draftKey);
    } catch (e) {
        console.error(`An error occurred while clearing draft ${draftKey}`);
        console.info(e);
    }
}

export function loadDraft(draftId) {
    try {
        const keyFromStorage = window.localStorage.getItem(getStorageKeyForDraft(draftId));
        if (!keyFromStorage) return null;

        const draft = JSON.parse(keyFromStorage);
        if (shouldClearDraft(draft.savedAt)) {
            clearDraft(draftId);
            return null;
        }
        return draft;
    } catch(e) {
        console.error(`Unable to load ${draftId}`);
        console.info(e)
        return null;
    }
}

// Returns true when the draft was written to storage, false when it could not be
// (storage disabled, quota exceeded). Callers use this to decide whether the
// learner still has unsaved work worth warning about before they leave.
export function saveDraft(draftId, answersToStore, attemptId = null) {
    try {
        const draft = JSON.stringify({ attemptId, responses: answersToStore, savedAt: Date.now() });
        window.localStorage.setItem(getStorageKeyForDraft(draftId), draft);
        return true;
    } catch (e) {
        console.error(`Unable to save ${draftId}`);
        console.info(e);
        return false;
    }
}
